import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { PATH } from '@constants';
import { useTenantRole } from '@hooks';

import { ChaseSpinner } from '@components';
import { Layout } from '@components/Layouts';

import { withSuspense } from './utils';

const ClusterSettings = lazy(
  () => import('@pages/ClusterSettings/ClusterSettingsPage'),
);
const ClusterGeneralSettings = lazy(
  () => import('@pages/ClusterSettings/ClusterGeneralSettingsOutlet'),
);
const ClusterUsersSettings = lazy(
  () => import('@pages/ClusterSettings/ClusterUsersSettingsOutlet'),
);
const ClusterSettingsReports = lazy(
  () => import('@pages/ClusterSettings/ClusterSettingsReportsOutlet'),
);

export default function ClusterSettingsRoutes() {
  const { isClusterManager, isTenantManager, isInitialized } = useTenantRole();

  const isManager = isClusterManager || isTenantManager;
  const defaultPath = isManager
    ? PATH.CLUSTER_SETTINGS
    : PATH.CLUSTER_SETTINGS_USERS;

  if (!isInitialized) {
    return (
      <Layout isProjectReffered={false} title="Cluster Settings">
        <Layout.Content>
          <div className="mt-24 flex justify-center">
            <ChaseSpinner color="black" className="h-14 w-14" />
          </div>
        </Layout.Content>
      </Layout>
    );
  }

  return (
    <Routes>
      <Route element={withSuspense(ClusterSettings, { isManager })}>
        {isManager && (
          <>
            <Route index element={withSuspense(ClusterGeneralSettings)} />
            <Route
              path="general"
              element={withSuspense(ClusterGeneralSettings)}
            />
          </>
        )}
        <Route
          path="users"
          element={withSuspense(ClusterUsersSettings, { isManager })}
        />
        <Route
          path="reports"
          element={withSuspense(ClusterSettingsReports, { isManager })}
        />
      </Route>
      <Route path="*" element={<Navigate replace to={defaultPath} />} />
    </Routes>
  );
}
